/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * WebhookSecretDtoBase
 * auto generated base class for the model WebhookSecretDtoModel.
 */
export const WebhookSecretDtoModelBase = ModelBase
  .named('WebhookSecretDto')
  .props({
    __typename: types.optional(types.literal("WebhookSecretDto"), "WebhookSecretDto"),
    /** Current signing secret used to verify webhook delivery signatures */
    secret: types.union(types.undefined, types.string),
    /** Previous signing secret, still valid during the post-rotation grace window */
    previousSecret: types.union(types.undefined, types.null, types.string),
    /** ISO timestamp when the previous secret stops being accepted */
    previousSecretInvalidAt: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class WebhookSecretDtoModelSelector extends QueryBuilder {
  get secret() { return this.__attr(`secret`) }
  get previousSecret() { return this.__attr(`previousSecret`) }
  get previousSecretInvalidAt() { return this.__attr(`previousSecretInvalidAt`) }
}
export function selectFromWebhookSecretDto() {
  return new WebhookSecretDtoModelSelector()
}

export const webhookSecretDtoModelPrimitives = selectFromWebhookSecretDto().secret.previousSecret.previousSecretInvalidAt
